/**
 * Cómo se llama cada cosa en la pantalla.
 *
 * El código trabaja con identificadores (`SALIDA_ARTIFICIAL`); quien opera
 * lee otra cosa. Están acá y no repartidos por las vistas para que el mismo
 * impacto no se llame de dos formas distintas según dónde se lo mire.
 */

/** Impactos, como sustantivo: sirve para informar lo que ya pasó. */
export const ETIQUETA_IMPACTO: Readonly<Record<string, string>> = {
  LICENCIA_ASISTENCIA_VIAJE: 'Licencia ASISTENCIA AL VIAJE',
  LICENCIA_SIN_TAREA: 'Licencia SIN TAREA',
  SALIDA_ARTIFICIAL: 'Salida al fin del turno',
};

/** El identificador crudo si aparece uno nuevo: mejor eso que un hueco. */
export const etiquetaAccion = (tipo: string): string => ETIQUETA_IMPACTO[tipo] ?? tipo;
